// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { CloudImageService } from "./CloudImageService";
import { IImageRetriever, Image, ImageStorageType } from "./IImageService";
import { LocalImageService } from "./LocalImageService";

@autoinject
export class ImageRetriever implements IImageRetriever {
    constructor(
        private readonly cloudImageService: CloudImageService,
        private readonly localImageService: LocalImageService
    ) {}

    public async getImage(id: string): Promise<Image> {
        // Always check local storage first so we wont need to bother the backend
        try {
            return await this.localImageService.getImage(id);
        } catch {
            return await this.cloudImageService.getImage(id);
        }
    }

    public getImageUri(image: Image): Promise<string> {
        switch (image.type) {
            case ImageStorageType.Cloud:
                return this.cloudImageService.getImageUri(image);
            case ImageStorageType.Local:
                return this.localImageService.getImageUri(image);
            default:
                return Promise.reject(new Error("Unknown ImageStorageType."));
        }
    }
}
